import { Component, Input, OnInit } from '@angular/core';
import { RFIDMember, RFIDMemberResponse } from 'src/app/core/services/facility.model';

@Component({
  selector: '[app-rfid-table-grid]',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.scss']
})
export class GridComponent implements OnInit {

  private _member: RFIDMember;

  // @Input() set member(val: RFIDMember) {
  //   this._member = val;
  // }

  // get member() {
  //   return this._member;
  // }

  constructor() { }

  ngOnInit(): void {
  }

}
